export default "__VITE_ASSET__IMAUpE48__"